import { Product } from '../types/product'
import { useFetchProducts } from './useFetchProducts'
import { useProductsListFilters } from './useProductsListFilters'

interface UseProductsResposne {
  isError: boolean
  isLoading: boolean
  products: Product[]
  totalItems: number
}

export const useProducts = (): UseProductsResposne => {
  const [filters] = useProductsListFilters()
  const { products, isLoading, totalItems, isError } = useFetchProducts(filters)

  return {
    isError,
    isLoading,
    products,
    totalItems,
  }
}
